import type { ReactNode } from 'react';

export const symbol_briefcase_meal: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-120q-24 0-42-18t-18-42v-480q0-24 18-42t42-18h180v-100q0-24 18-42t42-18h200q24 0 42 18t18 42v100h180q24 0 42 18t18 42v480q0 24-18 42t-42 18H140Zm0-60h180v-140q-26-6-43-27.5T260-397v-143q0-8 6-14t14-6q8 0 14 6t6 14v131h30v-131q0-8 6-14t14-6q8 0 14 6t6 14v131h30v-131q0-8 6-14t14-6q8 0 14 6t6 14v143q0 28-17 49.5T380-320v140h200v-108q-26-15-43-50.5T520-420q0-58 26-99t64-41q37 0 63.5 41t26.5 99q0 47-17 82.5T640-288v108h180v-480H140v480Zm240-540h200v-100H380v100ZM140-180v-480 480Z"
		/>
	</svg>
);
